var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMobileNumber01 = function SvgIconMobileNumber01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4.71,
    y1: 73.66,
    x2: 84.84,
    y2: 34.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.29,0H27.71c-3.71,0-6.75,3.04-6.75,6.75v86.49c0,3.72,3.04,6.76,6.75,6.76h44.58c3.71,0,6.75-3.03,6.75-6.75V6.75c0-3.72-3.04-6.75-6.75-6.75ZM42.87,4.87h14.26c.45,0,.82.37.82.82s-.37.82-.82.82h-14.26c-.45,0-.82-.37-.82-.82,0-.45.37-.82.82-.82ZM50,96.62c-1.87,0-3.38-1.51-3.38-3.38s1.51-3.38,3.38-3.38,3.38,1.51,3.38,3.38-1.51,3.38-3.38,3.38ZM74.35,87.5H25.65V10.71h48.69v76.79Z"
  })));
};
export default SvgIconMobileNumber01;